module.exports = __webpack_public_path__ + "static/media/panel_redes_sociales.137d253e.png";